var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-markdown-editor"},[_c('btn',{attrs:{"l":"Редактировать","i":"pencil","s":"m"},on:{"press":_vm.edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }